import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT_TOKEN } from '../../../../apps/values/environment.token';
import { MongoDBHttpService } from './mongodb-http/mongodb-http.service';
import { User } from '../../../../apps/types/user';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private _mongoHttpService = inject(MongoDBHttpService);
  private _environmentToken = inject(ENVIRONMENT_TOKEN);

  constructor() {}

  /**
   * Get user profile by Auth0 user ID
   * This works for both admin and therapist profiles since they extend User
   */
  getUserProfile(auth0UserId: string): Observable<User | null> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<User>(this._environmentToken.profilesCollection)
      .findOne({
        auth_zero_user_id: auth0UserId,
      });
  }

  /**
   * Update user profile by Auth0 user ID
   */
  updateUserProfile(
    auth0UserId: string,
    userUpdate: Partial<User>
  ): Observable<any> {
    return this._mongoHttpService
      .db(this._environmentToken.databaseName)
      .collection<User>(this._environmentToken.profilesCollection)
      .updateOne(
        {
          auth_zero_user_id: auth0UserId,
        },
        {
          $set: {
            ...userUpdate,
          },
        }
      );
  }
}
